<template>
    <v-container v-if="this.importJob !== null">
        <v-col cols="12">
            <v-row class="pa-2" justify="center" align="center">
                <h3>{{ this.importJob.feedback }}</h3>
            </v-row>

            <v-row v-if="this.importJob.totalCount > 0" 
                class="pa-2" justify="center" align="center"
            >
                <span>Items to process: {{ this.importJob.totalCount }}</span>
            </v-row>

            <v-row v-if="this.importJob.errorCount > 0"
                class="pa-2" justify="center" align="center"
            >
                <span>Items with errors: {{ this.importJob.errorCount }}</span>
            </v-row>
            <v-row 
                v-if="!(this.importJob.status === 2 || this.importJob.status === 3)"
                class="pa-2" 
                justify="center" 
                align="center"
            >
                <br>
                <v-progress-linear
                    v-model="percentageComplete"
                    color="blue-grey"
                    height="25"
                    reactive
                >
                    <template v-slot="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                </v-progress-linear>
                <br>
            </v-row>
        </v-col>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
    name: 'JobProgress',
    props: {
    },
    data(){ 
        return {
            importJobId: null,
            importJob: null,
            interval: null,
            percentageComplete: 0
        }
    },
    methods: {
        ...mapActions("assetxpstate", [
            "GetJob"
        ]),
        ...mapGetters("authentication", [
            "GetAuthHeaderObj"
        ]),
        setJobId(jobInfo) {
            this.importJobId = jobInfo.jobId;
            var i = jobInfo.intv === null || jobInfo.intv === undefined ? 1000 : jobInfo.intv;

            this.interval = setInterval(function () {
                this.updateJob();
            }.bind(this), i); 
        },
        updateJob() {
            if(this.importJobId !== null) {
                this.GetJob(this.importJobId).then((response) => {
                    this.importJob = response.data;

                    if(this.importJob !== null)
                    {
                        var complete = response.data.completedCount + response.data.errorCount;
                        this.percentageComplete = (complete / response.data.totalCount) * 100;
                        
                        if(this.importJob.status === 2 || this.importJob.status === 3)
                        {
                            clearInterval(this.interval);
                            this.$emit("JobFailure", null);
                        }
                    }
                });
            }
        }
    }
}
</script>